import { RefObject, useState, useEffect, useLayoutEffect, useRef } from 'react'

interface IProps {
  elementRef: RefObject<HTMLElement>
  lineHeight: number
}

const useHasMultiLine = ({ elementRef, lineHeight }: IProps) => {
  const [hasMultiline, setHasMultiline] = useState(true)
  const isMounted = useRef<boolean>(true)

  useLayoutEffect(() => {
    const node = elementRef.current

    if (node) {
      setTimeout(() => {
        if (isMounted.current) setHasMultiline(node.offsetHeight > lineHeight)
      }, 0)
    }
  }, [lineHeight, elementRef])

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  return hasMultiline
}

export default useHasMultiLine
